'use client';

import React from 'react';
import { ecx } from "../../../utils.mjs";
/**
 * The `ButtonChildren` component is an internal component used to render the children of `ButtonPrimary`, `ButtonSecondary`, and `ButtonTertiary`.
 * It is used to render icons and text in the correct order and with the correct spacing.
 */
export var ButtonChildren = function ButtonChildren(_ref) {
  var iconOnly = _ref.iconOnly,
    iconLeading = _ref.iconLeading,
    iconTrailing = _ref.iconTrailing,
    children = _ref.children,
    iconSize = _ref.iconSize;
  var renderIcon = function renderIcon(icon) {
    if (!icon) return null;
    var Icon = icon;
    return icon && /*#__PURE__*/React.createElement("span", {
      "aria-hidden": "true",
      className: ecx(['button__icon-wrapper'])
    }, /*#__PURE__*/React.createElement(Icon, {
      size: iconSize
    }));
  };
  return iconOnly ? /*#__PURE__*/React.createElement(React.Fragment, null, renderIcon(iconOnly)) : /*#__PURE__*/React.createElement(React.Fragment, null, renderIcon(iconLeading), children, renderIcon(iconTrailing));
};